"use strict";

var _interopRequireWildcard3 = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _interopRequireWildcard2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var device = _interopRequireWildcard3(require("@/api/device"));
var product = _interopRequireWildcard3(require("@/api/product"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _moment = _interopRequireDefault(require("moment"));
var _WarningRemoveModal = _interopRequireDefault(require("./components/WarningRemoveModal.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    WarningRemoveModal: _WarningRemoveModal.default
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      loadingButtonExcel: false,
      objData: {
        imei: ""
      },
      loadingSubmit: false,
      totalRecord: 0,
      arrDevice: [],
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        search: "",
        status: "REMOVED"
      },
      tableLoading: false
    };
  },
  watch: {
    "objData.imei": function objDataImei(val) {
      var arr = val.split("\n");
      var res = arr.filter(function (item) {
        if (item) return item;
      });
      this.totalRecord = res.length;
    }
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)({
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    downloadReport: function downloadReport() {
      var _this = this;
      var tHeader = ["Imei", "Cause", "Device type", "Device model"];
      this.loadingButtonExcel = true;
      product.getReportImeisRemoved().then(function (res) {
        Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require("@/vendor/Export2Excel"));
        }).then(function (excel) {
          var list = res.data;
          var data = [];
          var _iterator = (0, _createForOfIteratorHelper2.default)(list),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              data.push([item.imei, item.cause, item.deviceType, item.model ? item.model.name : ""]);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          excel.export_json_to_excel({
            header: tHeader,
            data: data,
            filename: "remove_imei_list"
          });
          _this.loadingButtonExcel = false;
        }).finally(function () {
          _this.loadingButtonExcel = false;
        });
      });
    },
    getTableData: function getTableData() {
      var _this2 = this;
      this.tableLoading = true;
      product.getImeis(this.listQuery).then(function (res) {
        _this2.tableData = res.data.data.data;
        _this2.total = res.data.data.total;
      }).finally(function () {
        _this2.tableLoading = false;
      });
    },
    removeImei: function removeImei() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var imeis, value, data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              imeis = _this3.objData.imei.split("\n").filter(function (e) {
                return e;
              });
              _context.next = 3;
              return _this3.$prompt("", "Cause remove", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                inputType: "textarea"
              });
            case 3:
              value = _context.sent;
              data = {
                cause: value.value,
                imei: imeis
              };
              _this3.$refs.WarningRemoveModal.visible = false;
              _this3.loadingSubmit = true;
              _context.next = 9;
              return product.removeImei(data);
            case 9:
              res = _context.sent;
              _this3.loadingSubmit = false;
              _this3.$message({
                type: "success",
                message: res.message
              });
              _this3.getTableData();
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleRemoveImei: function handleRemoveImei() {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var imeis, resultCheckData, inValidImeis, _iterator2, _step2, imei;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              imeis = _this4.objData.imei.split("\n").filter(function (e) {
                return e;
              });
              _this4.loadingSubmit = true;
              _context2.prev = 2;
              _context2.next = 5;
              return product.getImeis({
                page: 1,
                limit: 2000,
                imeis: imeis
              });
            case 5:
              resultCheckData = _context2.sent;
              inValidImeis = [];
              _iterator2 = (0, _createForOfIteratorHelper2.default)(resultCheckData.data.data.data);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  imei = _step2.value;
                  if (imei.status == "USED") {
                    inValidImeis.push(imei.imei);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              if (!inValidImeis.length) {
                _context2.next = 15;
                break;
              }
              _this4.loadingSubmit = false;
              _this4.$refs.WarningRemoveModal.handleOpen(inValidImeis);
              return _context2.abrupt("return");
            case 15:
              _this4.removeImei();
            case 16:
              _context2.prev = 16;
              _this4.loadingSubmit = false;
              return _context2.finish(16);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2,, 16, 19]]);
      }))();
    }
  }, "formatJson", function formatJson(filterVal, jsonData) {
    return jsonData.map(function (v) {
      return filterVal.map(function (j) {
        return v[j];
      });
    });
  }), "getHistoryDetail", function getHistoryDetail(inventoryId) {
    var _this5 = this;
    var tHeader = ["Imei", "Status", "Device type", "Device model", "Master Agent", "Distributor", "Retailer", "Employee", "Date"];
    var filterVal = ["imei", "status", "typeName", "modelName", "lv1", "lv2", "lv3", "lv4", "date"];
    this.tableLoading = true;
    product.getHistory(inventoryId).then(function (res) {
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/vendor/Export2Excel"));
      }).then(function (excel) {
        var list = res.data;
        var data = _this5.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data: data,
          filename: ""
        });
        _this5.tableLoading = false;
      });
    }).finally(function () {
      _this5.tableLoading = false;
    });
  })
};